
import { Component, Vue, Prop } from "vue-property-decorator";
import AsnModule from "@/store/modules/asn";
import { getModule } from "vuex-module-decorators";
import { AsnLevel } from "@/models/api/asn/asn";
import { AsnMap } from "@/models/api/asn/map";

const asnModule = getModule(AsnModule);

@Component
export default class DeleteMapModal extends Vue {

    @Prop({ default: null })
    AsnMap: AsnMap
}

